import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { FaLinkedinIn, FaWhatsapp, FaEnvelope, FaPhone } from "react-icons/fa";
import emailjs from '@emailjs/browser';

function ContactSection() {
  const [formData, setFormData] = useState({
    primeiroNome: '',
    sobrenome: '',
    email: '',
    mensagem: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Envio para o Google Forms
    // Substitua pela URL do formulário do Google Forms do FrontBPO
    const googleFormActionUrl = 'https://docs.google.com/forms/u/3/d/e/1FAIpQLSf0j-PWAN69hrvN-sshPSw0PXmSEWyI44glrUrhF0UYF2oSqw/formResponse';
    const formDataUrlEncoded = new URLSearchParams();
    formDataUrlEncoded.append('entry.374261425', formData.primeiroNome);
    formDataUrlEncoded.append('entry.743103423', formData.sobrenome);
    formDataUrlEncoded.append('entry.270276363', formData.email);
    formDataUrlEncoded.append('entry.655821332', formData.mensagem);
    formDataUrlEncoded.append('fvv', '1');
    formDataUrlEncoded.append('pageHistory', '0');
    formDataUrlEncoded.append('fbzx', '-8910435270898786220');

    const googlePromise = fetch(googleFormActionUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: formDataUrlEncoded,
    });

    const emailJsPromise = emailjs.send(
      'service_zm6lnqd',
      'template_8z835tp',
      formData,
      'u-3CElh3zvCuKa69C'
    );

    try {
      await Promise.all([googlePromise, emailJsPromise]);
      setSubmitted(true);

      // <-- ADICIONADO: Envia o evento de conversão para o Google Ads -->
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17619158225/kJ-tCNauhLUbENGJvNFB'
        });
      }
      // <-- FIM DA ADIÇÃO -->

    } catch (error) {
      console.error('Ocorreu um erro em uma das submissões:', error);
      alert('Ocorreu um erro ao enviar a mensagem. Tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contato">
      <Container>
        <Row>
          <Col md={5} className="contact-left-col">
            <h3 className="section-tagline">Contato</h3>
            <h2 className="contact-main-heading">Nosso escritório</h2>
            <p>
              Avenida das Nações Unidas 14261<br />
              São Paulo - BR
            </p>
            <div className="contact-social-icons">
              <a
                href="https://www.linkedin.com/company/action-executivos/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-link"
                aria-label="LinkedIn Front BPO"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=11996787054"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-link"
                aria-label="WhatsApp Eduardo Sandre"
              >
                <FaWhatsapp />
              </a>
              <a
                href="mailto:eduardosandre@actionexec.com"
                className="social-icon-link"
                aria-label="Email Eduardo Sandre"
              >
                <FaEnvelope />
              </a>
              <a
                href="tel:+5511996787054"
                className="social-icon-link"
                aria-label="Telefone Eduardo Sandre"
              >
                <FaPhone />
              </a>
            </div>
          </Col>

          <Col md={7} className="contact-right-col">
            {submitted ? (
              <div className="form-success-message">
                <h3>Obrigado!</h3>
                <p>Sua mensagem foi enviada com sucesso. Entraremos em contato em breve.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col sm={6} className="form-col">
                    <input type="text" name="primeiroNome" placeholder="Primeiro nome" value={formData.primeiroNome} onChange={handleChange} required className="form-input-action" />
                  </Col>
                  <Col sm={6} className="form-col">
                    <input type="text" name="sobrenome" placeholder="Sobrenome" value={formData.sobrenome} onChange={handleChange} required className="form-input-action" />
                  </Col>
                </Row>
                <input type="email" name="email" placeholder="E-mail *" value={formData.email} onChange={handleChange} required className="form-input-action" />
                <textarea name="mensagem" placeholder="Deixe sua mensagem aqui..." value={formData.mensagem} onChange={handleChange} required className="form-textarea-action"></textarea>
                <button type="submit" className="form-button-action" disabled={isSubmitting}>
                  {isSubmitting ? 'Enviando...' : 'Enviar'}
                </button>
              </form>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ContactSection;
